import axios from 'axios'
import Const from '@/helper/const'
import { custAxios } from './genericApi'

export default {
  getCardTransactionAuthorization (data) {
    return axios({
      method: 'post',
      url: `${Const.API_MERCADO_PAGO}/v1/card_tokens?public_key=${Const.MERCADO_PAGO_PUBLIC_KEY()}`,
      headers: {
        'Content-Type': 'application/json',
        'X-Product-Id': 'BCHJ1GABVKH001FP9V4G'
      },
      data
    })
  },
  paymentPackage (data) {
    const { credit } = data
    const headers = {
      Recaptcha: data.reCaptchaToken
    }

    delete data.reCaptchaToken
    delete data.credit

    if (credit) {
      return custAxios(headers).post(`${Const.API_BACKOFFICE_LOGGED_AREA}/payments/add-credit`, data)
    }

    return axios({
      method: 'post',
      url: credit ? `${Const.API_BACKOFFICE_LOGGED_AREA}/payments/add-credit` : `${Const.API_BACKOFFICE}/payments`,
      headers,
      data
    })
  }
}
